module.exports = __webpack_public_path__ + "img/icon_consignment.7db828b.webp";